/**
 * @generated SignedSource<<7b0a007f5bf10cbd113fda096d9d1392>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TabsContent_query$data = {
  readonly jira: {
    readonly containerNavigation: {
      readonly __typename: string;
      readonly extensions?: ReadonlyArray<{
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly message?: string | null | undefined;
      readonly navigationItems?: {
        readonly edges: ReadonlyArray<{
          readonly __typename: "JiraNavigationItemEdge";
          readonly node: {
            readonly id: string;
          };
        } | null | undefined> | null | undefined;
        readonly errors: ReadonlyArray<{
          readonly extensions: ReadonlyArray<{
            readonly statusCode: number | null | undefined;
          }> | null | undefined;
          readonly message: string | null | undefined;
        }> | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ContainerNavigationTabs_container">;
    };
  };
  readonly " $fragmentType": "TabsContent_query";
};
export type TabsContent_query$key = {
  readonly " $data"?: TabsContent_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"TabsContent_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v1 = [
  {
    "kind": "ScalarField",
    "name": "message"
  },
  {
    "kind": "LinkedField",
    "name": "extensions",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "statusCode"
      }
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "containerNavigationInput"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "name": "TabsContent_query",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "input",
                  "variableName": "containerNavigationInput"
                }
              ],
              "kind": "LinkedField",
              "name": "containerNavigation",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ContainerNavigationTabs_container"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "first",
                          "variableName": "first"
                        }
                      ],
                      "concreteType": "JiraNavigationItemConnection",
                      "kind": "LinkedField",
                      "name": "navigationItems",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraNavigationItemEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "kind": "RequiredField",
                              "field": {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "RequiredField",
                                    "field": {
                                      "kind": "ScalarField",
                                      "name": "id"
                                    },
                                    "action": "THROW",
                                    "path": "jira.containerNavigation.navigationItems.edges.node.id"
                                  }
                                ]
                              },
                              "action": "THROW",
                              "path": "jira.containerNavigation.navigationItems.edges.node"
                            }
                          ]
                        },
                        {
                          "concreteType": "QueryError",
                          "kind": "LinkedField",
                          "name": "errors",
                          "plural": true,
                          "selections": (v1/*: any*/)
                        }
                      ]
                    }
                  ],
                  "type": "JiraContainerNavigation"
                },
                (v0/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v1/*: any*/),
                  "type": "QueryError"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.containerNavigation"
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "b84967efe9fe4129379add71246146c1";

export default node;
